import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { map } from 'rxjs';
import { LoginService } from 'src/app/accountancy/authentication/login/login-service/login.service';
import { ApiRoutes } from 'src/app/accountancy/utilities/classes/api-routes.class';
import { Helper } from 'src/app/accountancy/utilities/classes/helper.class';
import { PromptMessage } from 'src/app/accountancy/utilities/classes/promp-message.class';
import { ApiGetResponse, ApiPutResponse } from 'src/app/accountancy/utilities/interfaces/global.interface';
import { ReimbursementInterface, ReimbursementStatusUpdate } from 'src/app/accountancy/utilities/interfaces/reimbursement.interface';
import { HttpApiService } from 'src/app/accountancy/utilities/services/http-api/http-api.service';

@Injectable({
  providedIn: 'root'
})
export class ReimbursementService {

  constructor(
    private _api: HttpApiService,
    private _loginS: LoginService,
  ) { }

  public approveRequest(controlId: string, remarks: string) {
    return this._api.sendPutRequest<HttpResponse<ApiPutResponse<ReimbursementInterface>>>(
      `/api/v1/reimbursement/${controlId}/approval`,
      {
        action: "Approved",
        remarks,
      },
      this._loginS.getTokenHeader,
    ).pipe(data => data);
  }

  public disapproveRequest(controlId: string, remarks: string) {
    return this._api.sendPutRequest<HttpResponse<ApiPutResponse<ReimbursementInterface>>>(
      `/api/v1/reimbursement/${controlId}/approval`,
      {
        action: "Disapproved",
        remarks,
      },
      this._loginS.getTokenHeader,
    ).pipe(data => data);
  }

  public getSingleReimbursement(controlNumber: string) {
    return this._api.sendGetRequest<HttpResponse<ReimbursementInterface>>(
      `${ApiRoutes.reimbursement}/${controlNumber}`,
      this._loginS.getTokenHeader,
    ).pipe(
      map(values => values.body),
    );
  }

  public updateStatus(controlNumber: string, body: Object) {
    return this._api.sendPutRequest<HttpResponse<ApiPutResponse<ReimbursementInterface>>>(
      `${ApiRoutes.reimbursement}/${controlNumber}/status`, body,
      this._loginS.getTokenHeader
    ).pipe(
      map(values => values.body),
    );
  }

  public updateItemStatus(
    controlNumber: string,
    itemId: number,
    body: ReimbursementStatusUpdate
  ) {
    return this._api.sendPutRequest(
      `${ApiRoutes.reimbursement}/${controlNumber}/item/${itemId}/status`,
      body,
      this._loginS.getTokenHeader
    );
  }

  public deleteMultipleReimbursement(controllNumbers?: string[] | null) {
    const formBody = {
      CntrlNumbers: controllNumbers,
      DeletedBy: this._loginS.userData?.ID,
    };

    return this._api.sendPostRequest<HttpResponse<any>>(ApiRoutes.reimbursementDeleteMultiple, formBody, this._loginS.getTokenHeader).pipe(
      map(values => values?.body)
    );
  }

  public deleteReibburesement(controllNumber?: string | null) {
    return this._api.sendDeleteRequest<HttpResponse<any>>(
      `${ApiRoutes.reimbursement}/${controllNumber}?DeletedBy=${this._loginS.userData?.ID}`,
      this._loginS.getTokenHeader
    ).pipe(
      map(values => values?.body),
    );
  }

  public updateReimbursement(controllNumber: string, body: Object) {
    return this._api.sendPutRequest<HttpResponse<any>>(`${ApiRoutes.reimbursement}/${controllNumber}`, body, this._loginS.getTokenHeader).pipe(
      map(values => values?.body),
    );
  }

  public newReimbursementItem(controllNumber: string, body: Object) {
    return this._api.sendPostRequest<HttpResponse<any>>(`${ApiRoutes.reimbursement}/${controllNumber}/item`, body, this._loginS.getTokenHeader).pipe(
      map(values => values?.body),
    );
  }

  public updateReimbursmentItem(controllNumber: string, itemId: number, body: Object) {
    return this._api.sendPutRequest<HttpResponse<any>>(`${ApiRoutes.reimbursement}/${controllNumber}/item/${itemId}`, body, this._loginS.getTokenHeader).pipe(
      map(values => values?.body),
    );
  }

  public deleteReimbursmentItem(controllNumber: string, itemId: number) {
    return this._api.sendDeleteRequest<HttpResponse<any>>(`${ApiRoutes.reimbursement}/${controllNumber}/item/${itemId}`, this._loginS.getTokenHeader).pipe(
      map(values => values?.body),
    );
  }

  public getReimbursementRequests(start?: number | null, limit?: number | null, query?: string | null, body?: Object) {
    return this._api.sendGetRequest<HttpResponse<ApiGetResponse<ReimbursementInterface>>>(
      Helper.url.toParams(ApiRoutes.reimbursement, {
        Start: start,
        Limit: limit,
        Search: query,
        ...body,
      }),
      this._loginS.getTokenHeader
    );
  }

  public newReimbursement(body: Object) {
    return this._api.sendPostRequest<HttpResponse<any>>(ApiRoutes.reimbursement, body, this._loginS.getTokenHeader).pipe(
      map(values => values?.body),
    );
  }

  public async printSelectedRItems(selectedRItems: ReimbursementInterface[]) {
    const documentContent: string = await fetch('assets/reports/r.report.html').then(data => data.text());
    const printWindow = window.open('Reimbursement', 'Reimbursement', 'width=500,height=400');
    printWindow?.document.write(`
      <script>
        const data = ${JSON.stringify(selectedRItems)};
      </script>
    `);
    printWindow?.document.write(documentContent);
  }

}
